import React from "react";
import ALDOTLogo from "../../src/assets/ALDOT-Logo.png";

const SaveSuccess = ({ onReset, title = "Thank You!", message = "Your submission has been received." }) => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-8 text-center">
          {/* Logo Section */}
          {/* <div className="mb-5">
            <img
              src={ALDOTLogo}
              alt="ALDOT Logo"
              className="aldot-responsive-logo"
              style={{ objectFit: "contain", width: "auto" }}
            />
          </div> */}

          {/* Success Card */}
          <div className="card border-0 shadow-sm rounded-0 py-5">
            <div className="card-body">
              <div className="mb-4">
                <i 
                  className="bi bi-check-circle-fill text-success" 
                  style={{ fontSize: "5rem" }}
                ></i>
              </div>
              
              <h1 className="fw-bold text-dark display-5">{title}</h1>
              <p className="lead text-muted mb-4">{message}</p>
              
              {onReset && (
                <button
                  onClick={onReset}
                  className="btn btn-primary px-5 py-2 rounded-0 text-uppercase fw-bold shadow-sm"
                >
                  Submit Another Entry
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .aldot-responsive-logo {
          height: 60px;
        }
        @media (min-width: 768px) {
          .aldot-responsive-logo { height: 100px; }
        }
        @media (min-width: 1200px) {
          .aldot-responsive-logo { height: 150px; }
        }
      `}</style>
    </div>
  );
};

export default SaveSuccess;